import { useEffect, type FC } from 'react';
import {
  useOrganisationServicePublic,
  type OrganisationServicePublicRequest,
} from 'src/apis/organisation-service/use-organisation-service-public';
import { useManualPublicOperatorsDetails } from 'src/apis/organisation-service/use-public-operator-details';
import {
  useSuperBundleOfferDetails,
  type SuperBundleOfferDetailsRequest,
} from 'src/apis/super-bundle-service/use-super-bundle-offer-details';
import { type SuperBundleServiceRequest } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { Page } from 'src/pages/transport/super-bundle/details/page';

export const SuperBundleOfferDetails: FC<{
  superBundleServiceRoot: Successful<SuperBundleServiceRequest>;
}> = ({ superBundleServiceRoot }) => {
  const superBundleOfferDetails = useSuperBundleOfferDetails({
    superBundleServiceRoot,
  });
  const organisationServicePublic = useOrganisationServicePublic();

  if (
    !superBundleOfferDetails.response ||
    !organisationServicePublic.response
  ) {
    return <PageSpinner />;
  }

  return (
    <LoadOperators
      superBundleOfferDetails={superBundleOfferDetails}
      superBundleServiceRoot={superBundleServiceRoot}
      organisationServicePublic={organisationServicePublic}
    />
  );
};

const LoadOperators: FC<{
  superBundleOfferDetails: Successful<SuperBundleOfferDetailsRequest>;
  superBundleServiceRoot: Successful<SuperBundleServiceRequest>;
  organisationServicePublic: Successful<OrganisationServicePublicRequest>;
}> = ({
  superBundleOfferDetails,
  superBundleServiceRoot,
  organisationServicePublic,
}) => {
  const { operatorProposals } = superBundleOfferDetails.response.data;
  const manualPublicOperatorDetails = useManualPublicOperatorsDetails();
  useEffect(() => {
    const urls = operatorProposals.map(
      (proposal) =>
        `${organisationServicePublic.response.data._links.getOperators.href}/${proposal.operatorId}`
    );
    manualPublicOperatorDetails.execute(urls);
    // oxlint-disable-next-line exhaustive-deps
  }, [operatorProposals, organisationServicePublic]);

  if (!manualPublicOperatorDetails.response) {
    return <PageSpinner />;
  }
  return (
    <Page
      superBundleOfferDetails={superBundleOfferDetails}
      superBundleServiceRoot={superBundleServiceRoot}
      manualPublicOperatorsDetails={manualPublicOperatorDetails}
    />
  );
};
